// Sentinel participantId for MyAgent's own messages in the group chat
export const MYAGENT_PARTICIPANT_ID = '__myagent__'

// Fixed color for MyAgent (host bot) — not hash-based
export const MYAGENT_COLOR = '#60a5fa'

// Built-in participant definition for MyAgent
export const MYAGENT_PARTICIPANT = {
  roleId: MYAGENT_PARTICIPANT_ID,
  displayName: 'MyAgent',
  roleType: 'host',
  description: 'Your AI assistant',
  isBuiltIn: true,
}

// Participant color palette (visually distinct on dark backgrounds)
export const PARTICIPANT_COLORS = [
  '#22d3ee', // cyan
  '#a78bfa', // violet
  '#f472b6', // pink
  '#34d399', // emerald
  '#fbbf24', // amber
  '#60a5fa', // blue
  '#fb923c', // orange
  '#e879f9', // fuchsia
]

export const hashString = (str) => {
  let hash = 0
  for (let i = 0; i < str.length; i++) hash = ((hash << 5) - hash + str.charCodeAt(i)) | 0
  return Math.abs(hash)
}
